module.exports = __webpack_public_path__ + "img/guide-13.8e11051b.jpg";